export default "__VITE_ASSET__BwNzxW_7__"